
import Vue from "vue";
import ProjectDetailsOverlay from "@/components/ProjectDetailsOverlay.vue";
import gameProjectsData from "@/data/GameProjectsData.ts";
import otherProjectsData from "@/data/OtherProjectsData.ts";
import ProjectData from "@/data/ProjectData.ts";

export default Vue.extend({
  name: "About",
  components: { ProjectDetailsOverlay },
  data() {
    return {
      projects: [...gameProjectsData, ...otherProjectsData],
      showPopup: false,
      popupTitle: "",
      popupColor: "",
      popupContent: "",
      popupIconUrl: "",
      heroBgOpacity: 1,
      heroBgTranslate: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onHeroScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onHeroScroll);
  },
  computed: {
    mainFeatured(): ProjectData | null {
      return (this.projects as ProjectData[]).find(p => p.isFeatured) || null;
    },
    featuredProjects(): ProjectData[] {
      return (this.projects as ProjectData[]).slice(0, 3);
    }
  },
  methods: {
    onHeroScroll() {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight;
      this.heroBgOpacity = Math.max(0, 1 - scrollY / (heroHeight * 0.6));
      this.heroBgTranslate = scrollY * 0.35;
    },
    openProject(item: ProjectData) {
      this.popupTitle = item.name;
      this.popupColor = item.accentColor;
      this.popupContent = item.htmlDescription;
      this.popupIconUrl = item.iconUrl;
      this.showPopup = true;
      window.scrollTo(0, 0);
    }
  }
});
